import { tokens } from "@/locales/translations/tokens";
import { useTranslation } from "react-i18next";

export function useFormmatedPlanName(planType: string | undefined) {
  const { t } = useTranslation();
  if (!planType) return 'Community Plan';
  
  switch (planType.toLowerCase()) {
    case 'commercial':
      return t(tokens.plans.commercial);
    case 'enterprise':
      return t(tokens.plans.enterprise)
    default:
      return t(tokens.plans.community)
  }
}